export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function formatJson(obj: unknown): string {
  try {
    return JSON.stringify(obj, null, 2);
  } catch {
    return String(obj);
  }
}

export function toggleRawView(nodeId: string, prefix: string, btn: HTMLElement) {
  const human = document.getElementById(`${prefix}-human-${nodeId}`);
  const raw = document.getElementById(`${prefix}-raw-${nodeId}`);
  if (!human || !raw) {
    return;
  }
  const showingRaw = !raw.classList.contains("tool-args-hidden");
  if (showingRaw) {
    raw.classList.add("tool-args-hidden");
    human.classList.remove("tool-args-hidden");
    btn.classList.remove("tool-args-toggle--active");
    btn.title = "Show raw JSON";
  } else {
    raw.classList.remove("tool-args-hidden");
    human.classList.add("tool-args-hidden");
    btn.classList.add("tool-args-toggle--active");
    btn.title = "Show formatted view";
  }
}

function looksLikePath(s: string): boolean {
  return /^[\w~]?[\/\\]/.test(s) || /^[A-Z]:\\/.test(s);
}

function formatValueHtml(value: unknown): string {
  if (value === null || value === undefined) {
    return `<span class="tool-args-value-null">null</span>`;
  }
  if (typeof value === "boolean") {
    return `<span class="tool-args-value-bool tool-args-value-bool--${value}">${value}</span>`;
  }
  if (typeof value === "number") {
    return `<span class="tool-args-value-number">${value}</span>`;
  }
  if (typeof value === "string") {
    const escaped = escapeHtml(value);
    if (looksLikePath(value)) {
      const lastSep = Math.max(value.lastIndexOf("/"), value.lastIndexOf("\\"));
      if (lastSep > 0) {
        const dir = escapeHtml(value.slice(0, lastSep + 1));
        const file = escapeHtml(value.slice(lastSep + 1));
        return `<span class="tool-args-value-path" title="${escaped}"><span class="tool-args-value-path-dir">${dir}</span>${file}</span>`;
      }
      return `<span class="tool-args-value-path">${escaped}</span>`;
    }
    if (value.includes("\n") || value.length > 80) {
      return `<code class="tool-args-value-code">${escaped}</code>`;
    }
    return escaped;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return `<span class="tool-args-value-null">[]</span>`;
    }
    if (value.every((v) => typeof v !== "object" || v === null)) {
      return escapeHtml(value.map(String).join(", "));
    }
    return `<div class="tool-args-nested">${formatArgsHuman(value)}</div>`;
  }
  if (typeof value === "object") {
    return `<div class="tool-args-nested">${formatArgsHuman(value)}</div>`;
  }
  return escapeHtml(String(value));
}

export function formatArgsHuman(obj: unknown): string {
  if (obj === null || obj === undefined) {
    return "";
  }
  if (typeof obj !== "object") {
    return `<pre>${escapeHtml(String(obj))}</pre>`;
  }
  const entries = Object.entries(obj as Record<string, unknown>);
  if (entries.length === 0) {
    return `<span class="tool-args-value-null">{}</span>`;
  }
  const rows = entries
    .map(
      ([key, val]) =>
        `<tr><td class="tool-args-key">${escapeHtml(key)}</td><td class="tool-args-value">${formatValueHtml(val)}</td></tr>`,
    )
    .join("");
  return `<table class="tool-args-table">${rows}</table>`;
}

export function formatTimestampLabel(ts: string): string {
  if (ts.length >= 15) {
    return `${ts.slice(0, 4)}-${ts.slice(4, 6)}-${ts.slice(6, 8)} ${ts.slice(9, 11)}:${ts.slice(11, 13)}:${ts.slice(13, 15)}`;
  }
  return ts;
}
